import _ from 'underscore';
import $ from 'jquery';

export default class OfferCampaignRecipientsPendingSpecial {
  constructor($scope, $timeout, OfferCampaignService, UiService) {
    $scope.tabs = [
      {
        title: 'Attachments Pending - Non PI',
        recipients: []
      },
      {
        title: 'Attachments Pending - PI',
        recipients: []
      },
      {
        title: 'Template Pending',
        recipients: []
      },
      {
        title: 'Ready to Send',
        recipients: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.check_items = function(tab_index, property) {
      _.each($scope.tabs[tab_index].recipients, function(recipient) {
        recipient[property] = $scope.tabs[tab_index].checked;
      });
    };

    $scope.load_recipients = function() {
      for (var i = 0; i < $scope.tabs.length; i++)
        $scope.tabs[i].recipients = [];
      $scope.loading = true;
      OfferCampaignService.get_recipients(window.offer_campaign.id, 1, 1).success(function(data) {
        $scope.tabs[0].recipients = _.filter(data.recipients, function(recipient) {
          return recipient.user_data.is_pi === false;
        });
        _.each(data.recipients, function(recipient) {
          $scope.allocate_recipient(recipient);
        });
        $scope.loading = false;
      });
    };

    $scope.allocate_recipient = function(recipient) {
      for (var i = 0; i < $scope.tabs.length; i++)
        $scope.remove_tab_recipient(i, recipient);

      if (!recipient.is_pending)
        return;

      var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
      var has_pi_xls = recipient.attachments && recipient.attachments.stocklist_pi_xls;
      var ignored_xls = recipient.attachments && recipient.attachments.ignore_xls;
      var ignored_pi_xls = recipient.attachments && recipient.attachments.ignore_pi_xls;
      var is_pi = recipient.user_data.is_pi;
      var has_template = !recipient.template_pending;
      var is_pi_ready = !is_pi || has_pi_xls || ignored_pi_xls;

      if ((has_xls || has_pi_xls) && has_template && is_pi_ready) {
        $scope.add_tab_recipient(3, recipient);
      } else {
        if (!is_pi && !has_xls)
          $scope.add_tab_recipient(0, recipient);
        if (is_pi && ((!has_xls && !ignored_xls) || (ignored_xls && ignored_pi_xls) || !is_pi_ready))
          $scope.add_tab_recipient(1, recipient);
        if (!has_template)
          $scope.add_tab_recipient(2, recipient);
      }
    };

    $scope.add_tab_recipient = function(index, recipient) {
      if (_.indexOf($scope.tabs[index].recipients, recipient) < 0)
        $scope.tabs[index].recipients.push(recipient);
    };

    $scope.remove_tab_recipient = function(index, recipient) {
      var recipient_index = _.indexOf($scope.tabs[index].recipients, recipient);
      if (recipient_index >= 0)
        $scope.tabs[index].recipients.splice(recipient_index, 1);
    };

    $scope.create_xls = function(recipient, create_stocklist_xls, create_pi_xls) {
      if (create_stocklist_xls)
        recipient.creating_xls = true;
      if (create_pi_xls)
        recipient.creating_pi_xls = true;
      OfferCampaignService.create_special_xls(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id, create_stocklist_xls, create_pi_xls).success(function(data) {
        if (data.success) {
          if (create_stocklist_xls)
            recipient.creating_xls = false;
          if (create_pi_xls)
            recipient.creating_pi_xls = false;
          recipient.attachments = data.attachments;
          $scope.allocate_recipient(recipient);
        }
      });
    };

    $scope.mass_create_xls = function(tab_index, index, create_stocklist_xls, create_pi_xls) {
      if (index === null) {
        $scope.xls_recipients = _.where($scope.tabs[tab_index].recipients, {
          checked_xls: true
        });
        if ($scope.xls_recipients.length > 0)
          $scope.mass_create_xls(tab_index, 0, create_stocklist_xls, create_pi_xls);
      } else {
        var recipient = $scope.xls_recipients[index];
        if (create_stocklist_xls)
          recipient.creating_xls = true;
        if (create_pi_xls)
          recipient.creating_pi_xls = true;
        OfferCampaignService.create_special_xls(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id, create_stocklist_xls, create_pi_xls).success(function(data) {
          if (data.success) {
            if (create_stocklist_xls)
              recipient.creating_xls = false;
            if (create_pi_xls)
              recipient.creating_pi_xls = false;
            recipient.attachments = data.attachments;
            $scope.allocate_recipient(recipient);
            if (index < $scope.xls_recipients.length - 1)
              $scope.mass_create_xls(tab_index, index + 1, create_stocklist_xls, create_pi_xls);
          }
        });
      }
    };

    $scope.get_xls = function(recipient, xls_filename) {
      $timeout(function() {
        $('form#getXLS input[name="user_id"]').val(recipient.user_id);
        $('form#getXLS input[name="xls_filename"]').val(xls_filename);
        $('form#getXLS').submit();
      }, 300);
    };

    $scope.set_recipient_attachment = function(recipient, attachments, loader_name) {
      recipient[loader_name] = true;
      OfferCampaignService.set_recipient_attachment(recipient.id, attachments).success(function(data) {
        if (data.success) {
          recipient.attachments = data.attachments;
          recipient[loader_name] = false;
          if (data.template_text)
            recipient.template_text = data.template_text;
          if (data.template_text_per)
            recipient.template_text_per = data.template_text_per;
          $scope.allocate_recipient(recipient);
        }
      });
    };

    $scope.mass_set_recipient_attachment = function(tab_index, index, attachments, loader_name) {
      if (index === null) {
        $scope.xls_recipients = _.where($scope.tabs[tab_index].recipients, {
          checked_xls: true
        });
        if ($scope.xls_recipients.length > 0)
          $scope.mass_set_recipient_attachment(tab_index, 0, attachments, loader_name);
      } else {
        var recipient = $scope.xls_recipients[index];
        recipient[loader_name] = true;
        OfferCampaignService.set_recipient_attachment(recipient.id, attachments).success(function(data) {
          if (data.success) {
            recipient[loader_name] = false;
            recipient.attachments = data.attachments;
            if (data.template_text)
              recipient.template_text = data.template_text;
            if (data.template_text_per)
              recipient.template_text_per = data.template_text_per;
            $scope.allocate_recipient(recipient);
            if (index < $scope.xls_recipients.length - 1)
              $scope.mass_set_recipient_attachment(tab_index, index + 1, attachments, loader_name);
          }
        });
      }
    };

    $scope.get_recipient_status = function(recipient) {
      var statuses = [];
      if (recipient.user_data.is_matched)
        statuses.push('Matched');
      if (recipient.user_data.ospp_policies)
        statuses.push('OSPP');
      if (recipient.user_data.is_pi)
        statuses.push('PI');
      return statuses.join(' + ');
    };

    $scope.edit_template = function(recipient) {
      $scope.dialog_edit_template_recipient = recipient;
      $.fancybox($('div#edit_template'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no',
        afterShow: function() {
          $scope.$broadcast('$tinymce:refresh');
        }
      });
    };

    $scope.save_template = function(is_done) {
      $scope.saving_template = true;
      var recipient = $scope.dialog_edit_template_recipient;
      OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, is_done).success(function(data) {
        if (data.success) {
          if (is_done) {
            recipient.template_pending = false;
            $scope.allocate_recipient(recipient);
          }
          $scope.saving_template = false;
          $.fancybox.close();
        }
      });
    };

    $scope.select_contacts = function(recipient) {
      $scope.dialog_select_contacts_recipient = recipient;
      $.fancybox($('div#select_recipient_contacts'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    };

    $scope.save_contacts = function() {
      $scope.saving_contacts = true;
      var recipient = $scope.dialog_select_contacts_recipient;
      var contacts = _.pluck(_.where(recipient.contacts, {
        checked: true
      }), 'id');
      OfferCampaignService.set_recipient_contacts(recipient.id, contacts).success(function(data) {
        if (data.success) {
          $scope.saving_contacts = false;
          $.fancybox.close();
        }
      });
    };

    $scope.auto_select_contacts = function(recipient) {
      recipient.auto_selecting_contacts = true;
      OfferCampaignService.auto_select_contacts(recipient.id).success(function(data) {
        if (data.success) {
          recipient.auto_selecting_contacts = false;
          recipient.contacts = data.contacts;
        }
      });
    };

    $scope.mass_auto_select_contacts = function(index) {
      if (index === null) {
        $scope.auto_select_recipients = _.where($scope.tabs[3].recipients, {
          checked_send: true
        });
        if ($scope.auto_select_recipients.length > 0)
          $scope.mass_auto_select_contacts(0);
      } else {
        var recipient = $scope.auto_select_recipients[index];
        recipient.auto_selecting_contacts = true;
        if (recipient.contacts.length > 0) {
          OfferCampaignService.auto_select_contacts(recipient.id).success(function(data) {
            if (data.success) {
              recipient.auto_selecting_contacts = false;
              recipient.contacts = data.contacts;
              if (index < $scope.auto_select_recipients.length - 1)
                $scope.mass_auto_select_contacts(index + 1);
            }
          });
        } else {
          recipient.auto_selecting_contacts = false;
          if (index < $scope.auto_select_recipients.length - 1)
            $scope.mass_auto_select_contacts(index + 1);
        }
      }
    };

    $scope.mass_select_contacts = function(index) {
      if (index === null) {
        $scope.mass_select_recipients = _.where($scope.tabs[3].recipients, {
          checked_send: true
        });
        if ($scope.mass_select_recipients.length > 0)
          $scope.mass_select_contacts(0);
      } else {
        var recipient = $scope.mass_select_recipients[index];
        var contacts = _.pluck(recipient.contacts, 'id');
        recipient.auto_selecting_contacts = true;
        if (recipient.contacts.length > 0) {
          OfferCampaignService.set_recipient_contacts(recipient.id, contacts).success(function(data) {
            if (data.success) {
              recipient.auto_selecting_contacts = false;
              recipient.contacts = data.contacts;
              if (index < $scope.mass_select_recipients.length - 1)
                $scope.mass_select_contacts(index + 1);
            }
          });
        } else {
          recipient.auto_selecting_contacts = false;
          if (index < $scope.mass_select_recipients.length - 1)
            $scope.mass_select_contacts(index + 1);
        }
      }
    };

    $scope.mass_mark_template_done = function(index) {
      if (index === null) {
        $scope.mark_done_recipients = _.where($scope.tabs[2].recipients, {
          checked_template: true
        });
        if ($scope.mark_done_recipients.length > 0)
          $scope.mass_mark_template_done(0);
      } else {
        var recipient = $scope.mark_done_recipients[index];
        recipient.marking_done = true;
        OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, true).success(function(data) {
          if (data.success) {
            recipient.template_pending = false;
            $scope.allocate_recipient(recipient);
            recipient.marking_done = false;
            if (index < $scope.mark_done_recipients.length - 1)
              $scope.mass_mark_template_done(index + 1);
          }
        });
      }
    };

    $scope.select_attachments = function(recipient) {
      $scope.$broadcast('show_select_attachments', {
        recipients: [recipient]
      });
    };

    $scope.mass_select_attachments = function() {
      var recipients = _.where($scope.tabs[3].recipients, {
        checked_send: true
      });
      if (recipients.length === 0) {
        alert('Please select at least one recipient!');
      } else {
        $scope.$broadcast('show_select_attachments', {
          recipients: recipients
        });
      }
    };

    $scope.send = function(recipient) {
      recipient.sending = true;
      OfferCampaignService.send_email(window.offer_campaign.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function(data) {
        if (data.success) {
          recipient.sending = false;
          recipient.is_pending = false;
          $scope.allocate_recipient(recipient);
        }
      });
    };

    $scope.mass_send = function(index) {
      if (index === null) {
        $scope.mass_send_recipients = _.where($scope.tabs[3].recipients, {
          checked_send: true
        });
        if ($scope.mass_send_recipients.length > 0)
          $scope.mass_send(0);
      } else {
        var recipient = $scope.mass_send_recipients[index];
        if (_.where(recipient.contacts, {checked: true}).length > 0) {
          recipient.sending = true;
          OfferCampaignService.send_email(window.offer_campaign.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function(data) {
            if (data.success) {
              recipient.sending = false;
              recipient.is_pending = false;
              $scope.allocate_recipient(recipient);
              if (index < $scope.mass_send_recipients.length - 1)
                $scope.mass_send(index + 1);
            }
          });
        } else {
          if (index < $scope.mass_send_recipients.length - 1)
            $scope.mass_send(index + 1);
        }
      }
    };

    $scope.update_embed_stocklist_pi = function(recipient) {
      recipient.updating_embed_stocklist_pi = true;
      OfferCampaignService.update_recipient_embed_pi(recipient.id, recipient.attachments.embed_stocklist_pi).success(function(data) {
        if (data.success) {
          recipient.updating_embed_stocklist_pi = false;
          recipient.template_text = data.template_text;
          recipient.template_text_per = data.template_text_per;
        }
      });
    };

    $scope.update_embed_stocklist_matched = function(recipient) {
      recipient.updating_embed_stocklist_matched = true;
      OfferCampaignService.update_recipient_embed_matched(recipient.id, recipient.attachments.embed_stocklist_matched).success(function(data) {
        if (data.success) {
          recipient.updating_embed_stocklist_matched = false;
          recipient.template_text = data.template_text;
          recipient.template_text_per = data.template_text_per;
        }
      });
    };

    $scope.mass_show_matched_quantity = function(tab_index, index) {
      if (index === null) {
        $scope.xls_recipients = _.where($scope.tabs[tab_index].recipients, {
          checked_xls: true
        });
        if ($scope.xls_recipients.length > 0)
          $scope.mass_show_matched_quantity(tab_index, 0);
      } else {
        var recipient = $scope.xls_recipients[index];
        OfferCampaignService.get_matched_quantity(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id).success(function(data) {
          if (data.success) {
            recipient.matched_quantity = data.matched_quantity;
            if (index < $scope.xls_recipients.length - 1)
              $scope.mass_show_matched_quantity(tab_index, index + 1);
          }
        });
      }
    };

    $scope.quick_search = function(tab_index) {
      window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
    };

    $scope.$on('load_offer_campaign_recipients', function(/*event, args*/) {
      $scope.load_recipients();
    });

    $scope.init = function() {
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.selected_tab = 0;
      $scope.offer_campaign = window.offer_campaign;
      $scope.current_page = 'recipients_pending_special';
      $scope.test_send = true;
      $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
      $scope._ = _;
      $scope.load_recipients();
    };

    $scope.init();
  }
}

OfferCampaignRecipientsPendingSpecial.$inject = ['$scope', '$timeout', 'OfferCampaignService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-recipients-pending-special.ctrl.js